import React, { useEffect } from 'react'
import Routes from './routes/Routes'
import i18n from './utils/i18n';
import { I18nextProvider } from 'react-i18next';
// import i18n from 'i18next';


const App = () => {
 
  return (
    <I18nextProvider i18n={i18n}>
      <Routes />
    </I18nextProvider>
  )
}

export default App